import React, { useEffect } from "react";
import DOMPurify from "dompurify";
export const SafeHTMLDisplay = ({ html, }) => {
    const safeHTML = DOMPurify.sanitize(html);
    useEffect(() => {
        DOMPurify.addHook("afterSanitizeAttributes", (node) => {
            if (node.tagName === "A") {
                node.setAttribute("target", "_blank");
                node.setAttribute("rel", "noopener noreferrer");
            }
            return node;
        });
    }, []);
    return React.createElement("div", { dangerouslySetInnerHTML: { __html: safeHTML } });
};
